import { render, staticRenderFns } from "./AmountModal.vue?vue&type=template&id=226b3de4&scoped=true&"
import script from "./AmountModal.vue?vue&type=script&lang=js&"
export * from "./AmountModal.vue?vue&type=script&lang=js&"
import style0 from "./AmountModal.vue?vue&type=style&index=0&id=226b3de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b3de4",
  null
  
)

export default component.exports